// 韩文

import twLocale from 'element-ui/lib/locale/lang/ko'

export default {
  ...twLocale
}
